"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var modifyProps = function modifyProps(props, baseClass) {
  return Object.assign({}, props, {
    className: (0, _classnames["default"])(baseClass, props.className),
    key: baseClass
  });
};

var propTypes = {
  description: _propTypes["default"].string,
  icon: _propTypes["default"].string
};
var defaultProps = {
  description: '',
  icon: null
};

var ListItem = function ListItem(props) {
  var description = props.description,
      icon = props.icon,
      otherProps = _objectWithoutPropertiesLoose(props, ["description", "icon"]);

  if (description) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("dt", modifyProps(otherProps, 'grv-list__term')), /*#__PURE__*/_react["default"].createElement("dd", modifyProps(otherProps, 'grv-list__description'), description));
  }

  if (icon) {
    return /*#__PURE__*/_react["default"].createElement("li", modifyProps(props, 'grv-list__item'), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      type: icon,
      className: "grv-list__icon"
    }), otherProps.children);
  }

  return /*#__PURE__*/_react["default"].createElement("li", modifyProps(props, 'grv-list__list-item'));
};

ListItem.propTypes = propTypes;
ListItem.defaultProps = defaultProps;
var _default = ListItem;
exports["default"] = _default;